import React from "react";
import { colors2, SkeletonLoader, UI_CAPTION_SEMIBOLD } from "oolib";
import { useElemInView } from "@/utils/customHooks/useElemInView";
import { AnnoCard } from "../../WidgetAnnotationExplorer/comps/AnnoCard";
import { WidgetLoadingState } from "../../../WidgetRenderer/comps/altStatePlaceholders";
import { useReportLandingContext } from "../../../../ReportLandingContext";
import { useAnnoDrilldown } from "./useAnnoDrilldown";

// WidgetErrorState is a red alert box — too loud for "nothing here".
const Msg = ({ children }) => (
  <UI_CAPTION_SEMIBOLD style={{ display: "block", color: colors2.grey60, padding: "1.4rem" }}>
    {children}
  </UI_CAPTION_SEMIBOLD>
);

/** Sits under the panel title, outside the scroll, so it survives scrolling. */
export const AnnoDrilldownCount = (props) => {
  const { annos, total, filters, status } = useAnnoDrilldown(props);
  // No total yet: say nothing rather than flash "20 of 20". None at all: the
  // panel's own empty state says it.
  if (!filters || status !== "success" || !total) return null;
  return (
    <UI_CAPTION_SEMIBOLD style={{ color: colors2.grey60 }}>
      {`Showing ${annos.length} of ${total}`}
    </UI_CAPTION_SEMIBOLD>
  );
};

export const AnnoDrilldownPanel = (props) => {
  const { reportId } = useReportLandingContext() || {};
  const { filters, annos, status, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useAnnoDrilldown(props);

  const { observerRef } = useElemInView({
    callback: fetchNextPage,
    enabled: !!hasNextPage && !isFetchingNextPage,
  });

  // The filter config is built off allTpls, so "none yet" is loading.
  if (!props.filterConfig || status === "loading") return <WidgetLoadingState />;
  if (!filters) return <Msg>This datapoint can't be drilled into.</Msg>;
  if (status === "error") return <Msg>Couldn't load these annotations.</Msg>;
  if (!annos.length) return <Msg>No annotations here.</Msg>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1.4rem" }}>
      {/* The card is the Annotation Explorer's own, so it carries the link to the
          source document, scrolled to this annotation. */}
      {annos.map((singleAnno, i) => (
        <AnnoCard
          key={singleAnno._id + (singleAnno.annotations?.annoKey || singleAnno.annoKey)}
          singleAnno={singleAnno}
          widgetName="Chart drill-down"
          reportId={reportId}
          lastCardObserverRef={i === annos.length - 1 && hasNextPage ? observerRef : null}
        />
      ))}
      {isFetchingNextPage && (
        <SkeletonLoader style={{ height: "10rem", borderRadius: "0.8rem" }} />
      )}
    </div>
  );
};
